/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from 'redux-immutable';
import { connectRouter } from 'connected-react-router/immutable';

import history from '$app/utils/history';
// import languageProviderReducer from 'containers/LanguageProvider/reducer';

import qs from 'qs';
import { LOCATION_CHANGE } from 'connected-react-router';
import { fromJS } from 'immutable';
import get from 'lodash/get';
// import globalReducer from 'containers/App/reducer';
// import authProviderReducer from 'containers/AuthProvider/reducer';

// Initial routing state
const routeInitialState = fromJS({
  location: null,
});

/**
 * Merge route into the global application state
 */
export function routeReducer(state = routeInitialState, action) {
  const location = get(action, 'payload.location', {});
  switch (action.type) {
    /* istanbul ignore next */
    case LOCATION_CHANGE:
      return state.merge({
        location: {
          /* default location payload */
          ...location,
          /* enhance search by parsing onto an object */
          search: qs.parse(location.search, {
            ignoreQueryPrefix: true,
          }),
        },
      });
    default:
      return state;
  }
}

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
export default function createReducer(injectedReducers = {}) {
  const rootReducer = combineReducers({
    router: connectRouter(history),
    route: routeReducer,
    // global: globalReducer,
    // authenticated: authProviderReducer,
    // language: languageProviderReducer,
    ...injectedReducers,
  });

  return rootReducer;
}
